import React, {useEffect,  useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import EstacionamientoService from "../../services/EstacionamientoService"
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import Botonera from "./Botonera";
import IndicadorCredito from "./IndicadorCredito";
import EPagosSites from "../EPagosSites";
import BotoneraWithFooter from "./BotoneraWithFooter";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";

const EstacionamientoPagoOk = () => {

var monto="0";
if (localStorage.getItem("estacionamiento_carga_monto")!=null)
    monto = localStorage.getItem("estacionamiento_carga_monto");
const n = parseInt(monto);
const formatted = n.toLocaleString('es-AR');

    const navigate=useNavigate();
      return (
        <section>
        <main> 
            <div class="okContent">
            <div class="row">
                <div class="col">
                    <img class="imageMicroClip" src="./est_pago_ok.svg"/>
                </div>
                </div>
                <div class="row">
                    <div class="col miniTextInverted">
                        Su cr&eacute;dito fue cargado correctamente
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col indicationText">
                    Cr&eacute;dito ingresado
                </div>
            </div>
            <div class="row">
                <div class="col indicationValue">
                    ${formatted}
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClipShort" onClick={()=> navigate("/estacionamiento")}>Ir a Inicio</button>
                </div>
                </div>
            </div>
            </main></section>);
}

export default EstacionamientoPagoOk;